module.exports = __webpack_public_path__ + "static/media/icon_e_wallet.c67455a8.png";